import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'

import { handlerServerError } from '@orbit/errors'

import { UsersWebPageUser } from '../../../types'

export const useResetMFA = (onReset: () => void) => {
  const confirmation = useConfirmation()

  const changeActiveStatus = useMutation<void, Error, { userId: string }>({
    mutationFn: (data) => Request.delete(Request.urls.bank.authMfaResetAll, data),
    onSuccess: async () => {
      onReset()
      Toast.success('Success', 'MFA devices were reset.')
    },
    onError: (error) => Toast.errorSmall(error.message)
  })

  const startEditing = async (user: UsersWebPageUser) => {
    const { firstName, lastName, id } = user
    const name = `${firstName} ${lastName}`.trim() || 'this'

    await confirmation.showDeleteConfirmation({
      message: `Are you sure you want to reset MFA devices for ${name} user?`,
      submitButtonText: 'Reset',
      confirmCallback: async () => {
        changeActiveStatus.mutateAsync({ userId: id }).catch((error) => handlerServerError(error))
      }
    })
  }

  return {
    startEditing
  }
}
